<script lang="ts">
export default {
  name: 'CustomFieldsColumn',
};
</script>

<template>
  <Column field="plant.custom_fields" :header="$t('glossary.custom_fields')">
    <template #body="slotProps">
      <div class="tag-container">
        <span
          class="keyValueTag my-1"
          v-for="(cf, index) in slotProps.data.plant.custom_fields"
          :key="index"
        >
          <span class="key"> {{ cf.type.name }}: </span>
          <span class="value">
            {{ cf.value }}
          </span>
        </span>
      </div>
    </template>
  </Column>
</template>

<style scoped>
.tag-container {
  margin-bottom: -0.4rem;

  span {
    &.tag {
      color: white;
      padding: 0.2rem 0.4rem;
      display: inline-block;
      background-color: $theme-color;
      margin-right: 0.6rem;
      margin-bottom: 0.4rem;
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
      border-radius: 4px;
    }

    &.keyValueTag {
      color: black;
      display: inline-block;
      margin-bottom: 0.4rem;

      span {
        padding: 0.2rem 0.4rem;
      }

      span.key {
        background: lightgray;
        font-weight: bold;
        border-bottom-left-radius: 4px;
      }

      span.value {
        background: darkgray;
        margin-right: 0.6rem;
        border-bottom-right-radius: 4px;
      }
    }
  }
}
</style>
